import $axios from '../../api'

const state = () => ({
  isError: false,
  isSuccess: false,

  memberBlacklist: [],
  memberBlacklistView: {},
  isLoading: false,
  page: 1,
})

const mutations = {
  ASSIGN_MEMBER_BLACKLIST(state, payload) {
    state.memberBlacklist = payload
  },
  ASSIGN_MEMBER_BLACKLIST_VIEW(state, payload) {
    state.memberBlacklistView = payload
  },
  ASSIGN_ERRORS(state, payload) {
    state.isError = payload
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_PAGE(state, payload) {
    state.page = payload
  }
}

const actions = {
  fetchList({ commit, state, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true)
      $axios
        .get(`/website/member-blacklist/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
        .then((response) => {
          commit("ASSIGN_MEMBER_BLACKLIST", response.data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    })
  },
  create({ commit, state, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true)
      $axios
        .post("/website/member-blacklist/create", {member_id: payload?.member_id})
        .then((response) => {
          commit("SET_SUCCESS", true)
          resolve()
        })
        .catch((error) => {
          console.log(error.response.data.errors);
          commit("ASSIGN_ERRORS", error.response.data.errors);
          dispatch("Main/globalSweetAlert", error.response, {root: true});
          reject(error)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    })
  },
  view({ commit, state, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true)
      $axios
        .get("/website/member-blacklist/view/" + payload?.id)
        .then((response) => {
          commit("ASSIGN_MEMBER_BLACKLIST_VIEW", response.data.data)
          resolve()
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, {root: true});
          reject(error)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    })
  },
  update({ commit, state, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true)
      $axios
        .put("/website/member-blacklist/update/" + payload?.id, {member_id: payload?.member_id})
        .then((response) => {
          resolve()
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          dispatch("Main/globalSweetAlert", error.response, {root: true});
          reject(error)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    })
  },
  showhide({ commit, state, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true)
      $axios
        .delete("/website/member-blacklist/showhide/" + payload)
        .then((response) => {
          resolve()
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          dispatch("Main/globalSweetAlert", error.response, {root: true});
          reject(error)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}